export default __webpack_public_path__ + "static/onyx-90c909fddb1d2b7e80ed05e90489c797.png";